import { render, staticRenderFns } from "./infographics.vue?vue&type=template&id=3867d0eb&scoped=true"
import script from "./infographics.vue?vue&type=script&lang=js"
export * from "./infographics.vue?vue&type=script&lang=js"
import style0 from "./infographics.vue?vue&type=style&index=0&id=3867d0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3867d0eb",
  null
  
)

export default component.exports